

























































import { Prop, Component, Vue } from "vue-property-decorator";
import VDelete from "@/components/VDelete.vue";
import VRename from "@/components/file/VRename.vue";
import { FolderEntry } from "@/models/file";

@Component({
  components: {
    VDelete,
    VRename
  }
})
export default class VFolder extends Vue {
  @Prop({ required: true }) entries!: FolderEntry[];
  @Prop({ type: Boolean, default: () => false }) isEstimateTemplate?: Boolean;
  @Prop({ type: Array }) fields?: [];

  renameFolder(name: string, entry: FolderEntry) {
    this.$emit("renameFolder", entry, name);
  }

  removeFolder(entry: FolderEntry) {
    this.$emit("removeFolder", entry);
  }
}
